import { FC } from 'react';

import BeneficiaryTenderOfferSelectorModalHeader from './components/BeneficiaryTenderOfferSelectorModalHeader';
import BeneficiaryTenderOfferSelectorModalBody from './components/BeneficiaryTenderOfferSelectorModalBody';
import BeneficiaryTenderOfferSelectorModalFooter from './components/BeneficiaryTenderOfferSelectorModalFooter';

const BeneficiaryTenderOfferSelectorModal: FC = () => (
  <>
    <BeneficiaryTenderOfferSelectorModalHeader />
    <BeneficiaryTenderOfferSelectorModalBody />
    <BeneficiaryTenderOfferSelectorModalFooter />
  </>
);

export default BeneficiaryTenderOfferSelectorModal;
